import React from "react";
import { Link } from "react-router-dom";

import TableV2 from "src/components/ui/TableV2";
import { formatDateTime } from "src/utils/date-time";
import { currencyFormatter } from "src/utils/common";
import { ITenantRecentSaleOrder } from "src/types/dashboard.types";

interface RecentSalesTableProps {
  rows: ITenantRecentSaleOrder[];
}

const RecentSalesTable: React.FC<RecentSalesTableProps> = ({ rows }) => {
  return (
    <TableV2
      columns={[
        {
          key: "orderId",
          header: "Order",
          accessor: ({ row }) => (
            <Link to={`/app/sale/${row._id}`} className="text-primary-600">
              {row.orderId}
            </Link>
          ),
        },
        {
          key: "customer",
          header: "Customer",
          accessor: ({ row }) => row.customerId?.name || "-",
        },
        {
          key: "grandTotal",
          header: "Total",
          align: "right",
          accessor: ({ row }) => currencyFormatter(row.grandTotal || 0),
        },
        {
          key: "createdAt",
          header: "Date",
          align: "center",
          accessor: ({ row }) =>
            formatDateTime(row.createdAt, "DD/MM/YYYY hh:mm:ss A"),
        },
      ]}
      data={rows}
    />
  );
};

export default RecentSalesTable;
